import React from 'react';

// Options:
// {
//   weekday: "short", // "narrow", "short", "long"
//   year: "numeric", // "2-digit", "numeric"
//   month: "2-digit", // "2-digit", "numeric", "narrow", "short", "long"
//   day: "2-digit", // "2-digit", "numeric"
// }
export const DateFormat = ({
  date = new Date(),
  options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  },
}) => {
  if (!date) return null;
  const formattedDate = new Date(date).toLocaleDateString(
    localStorage.locale || "nl-NL",
    options
  );
  return <span style={{whiteSpace: 'nowrap'}}>{formattedDate}</span>;
};
